import { VimeoVideo } from '@helpers/VimeoPlayer';
import { YoutubeVideo } from '@helpers/YoutubePlayer';
import { closeOverlayEvent, videoOverlayWrapper } from '@helpers/VideoOverlay';
import { getClassFunction } from '@helpers/functions';
import { VideoSourceModel } from '@_types/organisms';

const getClass = getClassFunction('kf-o-video');

class Video {
  video: HTMLElement;
  videoPlayer: YoutubeVideo | VimeoVideo | null = null;
  thumbnail: HTMLElement | null = null;

  constructor(video: HTMLElement) {
    this.video = video;
  }

  init() {
    this.addOpenOverlayEvent();
    this.addEventCloseVideoOverlay();
  }

  setVideoPlayer(source: VideoSourceModel) {
    const iframe = videoOverlayWrapper.videoOverlay?._iframe;

    if (!iframe) return;

    if (this.videoPlayer) {
      const isYoutubePlayer = this.videoPlayer instanceof YoutubeVideo;
      const isVimeoPlayer = this.videoPlayer instanceof VimeoVideo;

      if ((isYoutubePlayer && source === 'youtube') || (isVimeoPlayer && source === 'vimeo')) return;
    }

    let videoPlayer: YoutubeVideo | VimeoVideo;

    if (source === 'youtube') {
      videoPlayer = new YoutubeVideo(iframe);
    } else {
      videoPlayer = new VimeoVideo(iframe);
    }

    this.videoPlayer = videoPlayer;
  }

  onCloseVideoOverlay() {
    if (this.videoPlayer?.onPauseVideo) {
      this.videoPlayer.onPauseVideo();

      if (this.thumbnail?.dataset.active === 'true') {
        this.thumbnail?.focus();
        this.thumbnail?.removeAttribute('data-active');
      }
    }
  }

  addEventCloseVideoOverlay() {
    window.addEventListener(closeOverlayEvent, () => {
      this.onCloseVideoOverlay();
    });
  }

  onOpenVideoOverlay() {
    if (!videoOverlayWrapper.videoOverlay?._overlay) {
      return;
    }

    this.thumbnail?.setAttribute('data-active', 'true');

    videoOverlayWrapper.videoOverlay.toggleVideoOverlay(true);

    const source = this.video.dataset.source as VideoSourceModel;
    const videoId = this.video.dataset.videoId as string;

    videoOverlayWrapper.videoOverlay.setVideoOverlayData(source, videoId);

    setTimeout(() => {
      this.setVideoPlayer(source);
    }, 0);
  }

  addOpenOverlayEvent() {
    this.thumbnail = this.video.querySelector<HTMLElement>(getClass('thumbnail-container'));

    this.thumbnail?.addEventListener('click', () => {
      this.onOpenVideoOverlay();
    });

    this.thumbnail?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        this.onOpenVideoOverlay();
      }
    });
  }
}

window.addEventListener('load', () => {
  const videoContainers = document.querySelectorAll<HTMLElement>(getClass());

  for (const video of videoContainers) {
    new Video(video).init();
  }
});

export {};
